<swap-modal [modalId]="modalId" [centered]="true">
  <div class="row m-3">
    <div class="col-12 d-flex mb-3">
      <h5 class="modal-title mb-0 fw-bolder" id="exampleModalLabel">
        Extend Time
      </h5>
      <button
        type="button"
        class="closeBtn d-none"
        data-bs-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <img loading="lazy" src="assets/icons/close-icon.svg" alt="" />
      </button>
    </div>
    <div class="col-12 mb-2">
      <p>
        <b>{{ requestor }}</b> would like to extend the time of the transaction.
      </p>
      <p class="mb-0">Click <b>confirm</b> to approve time extension.</p>
      <div class="d-flex align-items-center gap-2 mt-4">
        <button
          (click)="emitConfirmation.emit(false); closeBtn.click()"
          class="submit-btn fw-700 font-13 btn-decline"
        >
          Decline
        </button>
        <button
          class="submit-btn fw-700 font-13"
          (click)="emitConfirmation.emit(true); closeBtn.click()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</swap-modal>
